@if (comments$ | async; as comments) {
  @if (comments.length > 0) {
    <div data-test-id="linked-comment-content">
      <app-view-comments [comments]="comments" [readOnly]="true"></app-view-comments>
    </div>
  } @else {
    <p data-test-id="linked-comments-empty">{{ 'linked_comments_empty' | translate }}</p>
  }
}
